import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from '@codametrix/ui-components';
import React from 'react';
import { useDispatch } from 'react-redux';
import { cancelEula } from '../../actions/eula';
import { logoutApp } from '../../actions/login.action';
const CancelledEula = ()=>{
    const dispatch = useDispatch();
    const submitClick = (e)=>{
        dispatch(cancelEula(false));
        dispatch(logoutApp({
            showModal: false
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: 'qa-cancelled-eula',
        children: /*#__PURE__*/ _jsx(Modal, {
            title: 'You must accept the EULA to use the application',
            buttonText: 'Return',
            closable: false,
            onSubmit: submitClick,
            forceSubmitOptions: {
                isForced: true,
                time: 10,
                message: 'Returning to the login screen '
            },
            children: /*#__PURE__*/ _jsx("p", {
                children: "Please review the EULA and try again."
            })
        })
    });
};
export default CancelledEula;
